<div class="righttrack">
  <div [ngClass]="{topright:true, expanded: collapsed, fullscreen: fullscreenmap}" id="topright">
    <simple-map [mapMode]="'tracking'"></simple-map>
  </div>
  <div (mousedown)="splitterDown()" class="hor_splitter" id="hor_right_splitter" *ngIf="!fullscreenmap">
    <span></span>
  </div>
  <div [ngClass]="{bottomright:true, collapsed:collapsed}" id="bottomright" *ngIf="!fullscreenmap">
    <div class="btns">
      <div class="btn_tabs">
        <button class="active">{{'Events'|translate }}</button>
      </div>
      <button class="btn_img_large btn_show_checked_off" id="showEnabledOnlyBtn" title="{{'Show enabled objects only'|translate }}"></button>
      <button class="btn_blue" id="ackevents">{{'Acknowledge'|translate }}</button>
      <button class="btn_img_large btn_graygray btn_down" (click)="this.collapseRightBottom()"></button>
    </div>
    <div class="bottomrighttables" id="bottomright_tables">
      <app-events-list [trackingMode]="true"></app-events-list>
    </div>
  </div>
</div>
